export default __webpack_public_path__ + "static/v-bg-top-7c8136893ebbc3ec6500f776181160c2.png";